
import './App.css';
import Dashoard from './components/Dashoard';
import Sidebar from './components/Sidebar';


function App() {
  return (
    <div className="App">
      <Sidebar />
      <Dashoard />
    </div>
  );
}

export default App;
